/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { LayerDataResponseVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * MockExportImportControllerApi - axios parameter creator
 * @export
 */
export const MockExportImportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFeaturesMock: async (files?: Array<File>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/geodata/features/import/mock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MockExportImportControllerApi - functional programming interface
 * @export
 */
export const MockExportImportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MockExportImportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importFeaturesMock(files?: Array<File>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LayerDataResponseVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.importFeaturesMock(files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MockExportImportControllerApi - factory interface
 * @export
 */
export const MockExportImportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MockExportImportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFeaturesMock(files?: Array<File>, options?: any): AxiosPromise<Array<LayerDataResponseVO>> {
            return localVarFp.importFeaturesMock(files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MockExportImportControllerApi - interface
 * @export
 * @interface MockExportImportControllerApi
 */
export interface MockExportImportControllerApiInterface {
    /**
     * 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MockExportImportControllerApiInterface
     */
    importFeaturesMock(files?: Array<File>, options?: any): AxiosPromise<Array<LayerDataResponseVO>>;

}

/**
 * MockExportImportControllerApi - object-oriented interface
 * @export
 * @class MockExportImportControllerApi
 * @extends {BaseAPI}
 */
export class MockExportImportControllerApi extends BaseAPI implements MockExportImportControllerApiInterface {
    /**
     * 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MockExportImportControllerApi
     */
    public importFeaturesMock(files?: Array<File>, options?: any) {
        return MockExportImportControllerApiFp(this.configuration).importFeaturesMock(files, options).then((request) => request(this.axios, this.basePath));
    }
}
